import moment from "moment";
import { FIELD_LABELS } from "../constants/logs";

function sortTuple(s) {
  if (s.startsWith("GWDES")) {
    return [1, s];
  } else if (s.startsWith("GDAES")) {
    return [2, s.slice(8), s];
  } else if (s.startsWith("GWEES")) {
    return [3, s];
  } else if (s.startsWith("GBoMES")) {
    return [4, s];
  } else if (s.startsWith('GMAES')) {
    return [5, s];
  } else if (s.startsWith('GMES')) {
    return [6, s];
  } else if (s.startsWith('GQES')) {
    return [7, s];
  } else if (s.startsWith('GSES')) {
    return [8, s];
  } else if (s.startsWith('GYES')) {
    return [9, s];
  } else if (s.startsWith('GWDPT')) {
    return [10, s];
  } else if (s.startsWith('GDAPT')) {
    return [11, s.slice(8), s];
  } else if (s.startsWith('GWEPT')) {
    return [12, s];
  } else if (s.startsWith('WD_TVB')) {
    return [13, s];
  } else if (s.startsWith('DA_TVB')) {
    return [14, s];
  } else if (s.startsWith('D_TVB')) {
    return [15, s.slice(8), s];
  } else if (s.startsWith('BoM_TVB')) {
    return [16, s];
  } else if (s.startsWith('M_TVB')) {
    return [17, s];
  } else if (s.startsWith('WD_AVB')) {
    return [18, s];
  } else if (s.startsWith('DA_AVB')) {
    return [19, s];
  } else if (s.startsWith('PVB_TTF')) {
    if (s.length === 16) { //daily
      return [20, s.slice(10), s];
    } else if (s.length === 15) { //BoM
      return [21, s.slice(8), s];
    } else if (s.length === 12) {
      if (s[10] !== 'Q') { //monthly
        return [22, s];
      } else { //quarter
        return [23, s];
      }
    } else if (s.length === 11) { //season
      return [24, s];
    } else { //anual
      return [25, s];
    }
  } else if (s.startsWith('PVB_LPI')) {
    if (s.length === 16) { //daily
      return [26, s.slice(10), s];
    } else if (s.length === 15) { //BoM
      return [27, s.slice(8), s];
    } else if (s.length === 12) {
      if (s[10] !== 'Q') { //monthly
        return [28, s];
      } else { //quarter
        return [29, s];
      }
    } else if (s.length === 11) { //season
      return [30, s];
    } else { //anual
      return [31, s];
    }
  } else {
    return [32, s];
  }
}

export function customSort(a, b) {
  const keyA = sortTuple(a);
  const keyB = sortTuple(b);
  for (let i = 0; i < keyA.length; i++) {
    if (keyA[i] < keyB[i]) {
      return -1;
    } else if (keyA[i] > keyB[i]) {
      return 1;
    }
  }
  return 0;
};

export function getCurve(ticker) {
  const index = sortTuple(ticker)[0]
  if (index >= 1 && index <= 9) {
    return 'Curva PVB'
  } else if (index >= 10 && index <= 12) {
    return 'Curva VTP'
  } else if (index >= 13 && index <= 17) {
    return 'Curva TVB'
  } else if (index >= 18 && index <= 19) {
    return 'Curva AVB'
  } else if (index >= 20 && index <= 25) {
    return 'Curva Spread PVB-TTF'
  } else if (index >= 26 && index <= 31) {
    return 'Curva PVB Last Price Index'
  } else {
    return 'Otros productos'
  }
}

export const compareArrays = (original, currentData) => {
  const result = [];
  original.forEach((originalObject, index) => {
    const updatedObject = currentData[index];
    const updaterobj = {};
    Object.keys(originalObject).forEach(key => {
      if (originalObject[key] !== updatedObject[key]) {
        updaterobj[key] = updatedObject[key];
      }
    });
    if (Object.keys(updaterobj).length !== 0) {
      updaterobj.dtime = originalObject.dtime;
      updaterobj.instrument = originalObject.instrument;
      updaterobj.original_settle_last_modification =
        originalObject.settle_last_modification ?? null;
      result.push(updaterobj);
    }
  });
  return result;
}

export const valSetter = (value, row, k) => {
  if (value === "") {
    value = null;
  }
  row[k.field] = value;
  return { ...row };
};

export function compByProduct(data) {
  let interim = data.reduce((map, obj) => {
    const prod = obj.product;
    if (!map.has(prod)) {
      map.set(prod, []);
    }

    map.get(prod).push(obj);

    return map;
  }, new Map());
  interim.forEach((array, key) => {
    array.sort((a, b) => new Date(a.dtime) - new Date(b.dtime));
    interim.set(key, array); // Update the map with the sorted array
  });
  return interim;
}

export function monthsByMM(data) {
  return data.reduce((map, obj) => {
    const mm = obj.market_maker;

    if (!map.has(mm)) {
      map.set(mm, { months: new Map() });
    }

    map.get(mm).months.set(moment(obj.dtime).format("MMMM YYYY"), obj.dtime);

    return map;
  }, new Map());
}

export function getRowKey(tabkey, row) {
  return `${tabkey}🦕${row["id"]}`;
}

export function delR(oldRows, tabName, id) {
  let nuData = { ...oldRows };

  nuData[tabName] = nuData[tabName].filter((row) => row.id !== id);

  return nuData;
}

export function addR(oldRows, tabName, month) {
  let nuData = { ...oldRows };
  let nuidx =
    nuData[tabName].length > 0
      ? Math.max(...nuData[tabName].map((obj) => obj.id)) + 1
      : 0;
  let pritem = { dtime: month, isNew: true, id: nuidx };
  if (tabName === "marketconditions") {
    pritem["market_conditions"] = "";
  }

  nuData[tabName] = [...nuData[tabName], pritem];

  return nuData;
}

/**
* Builds query parameters for fetching audit logs based on the provided filter model
* @param {Object} model - The filter model containing filter items
* @returns {Object} An object with query parameters for the API request
*/
export const buildAuditLogFilterParams = (model) => {
  const params = {};
  const items = Array.isArray(model?.items) ? model.items : [];

  items.forEach((item) => {
    const { field, operator, value } = item || {};
    if (!field || value === undefined || value === null || value === "") return;

    if (field === "action_type") {
      params.actionType = value;
    }

    if (field === "username") {
      params.username = value;
    }

    if (field === "created_at") {
      const normalizedDate = String(value);
      if (operator === "after" || operator === "onOrAfter") {
        params.startDate = normalizedDate;
      } else if (operator === "before" || operator === "onOrBefore") {
        params.endDate = normalizedDate;
      } else {
        params.startDate = normalizedDate;
        params.endDate = normalizedDate;
      }
    }
  });

  return params;
};

export const buildDagLogFilterParams = (model) => {
  const params = {};
  const items = Array.isArray(model?.items) ? model.items : [];

  items.forEach((item) => {
    const { field, operator, value } = item || {};
    if (!field || value === undefined || value === null || value === "") return;

    if (field === "status") {
      params.status = value;
    }

    if (field === "timestamp") {
      const normalizedDate = String(value);
      if (operator === "after" || operator === "onOrAfter") {
        params.startDate = normalizedDate;
      } else if (operator === "before" || operator === "onOrBefore") {
        params.endDate = normalizedDate;
      } else {
        params.startDate = normalizedDate;
        params.endDate = normalizedDate;
      }
    }
  });

  return params;
};

export const formatChangeValue = (value) => {
  if (value === null || value === undefined) return "-";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

const formatChangePropertyBase = (property) => {
  if (!property) return "-";
  const value = String(property);
  const openIndex = value.indexOf("[");
  const closeIndex = value.lastIndexOf("]");

  if (openIndex !== -1 && closeIndex !== -1 && closeIndex > openIndex) {
    const prefix = value.slice(0, openIndex).trim();
    const inside = value.slice(openIndex + 1, closeIndex).trim();
    if (!prefix) return inside || value;
    return `${prefix} ${inside}`.trim();
  }

  return value;
};

export const formatChangeProperty = (property) => {
  if (!property) return "-";
  const parts = String(property).split(".");
  const base = parts.shift();
  const field = parts.join(".");
  const baseLabel = formatChangePropertyBase(base);

  if (!field) return baseLabel;

  const fieldLabel = FIELD_LABELS[field] ?? field;
  if (!baseLabel) return fieldLabel;
  return `${baseLabel} - ${fieldLabel}`;
};

export const formatAuditLogChange = (change) => {
  const propertyLabel = formatChangeProperty(change?.property);
  const changedValue = change?.changed_value;
  const isCreation = changedValue === "[NUEVO]";
  const isDeletion = changedValue === "[ELIMINADO]";

  if (isCreation) {
    return {
      isPlainText: true,
      text: `Registro creado: ${propertyLabel}`,
    };
  }

  if (isDeletion) {
    return {
      isPlainText: true,
      text: `Registro eliminado: ${propertyLabel}`,
    };
  }

  return {
    isPlainText: false,
    label: propertyLabel,
    originalValue: formatChangeValue(change?.original_value),
    changedValue: formatChangeValue(change?.changed_value),
  };
};

export const formatRoute = (path) => {
  if (!path) return path;
  return path.replace(/-/g, " → ");
};

export const currentTime = () =>
  new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });

export const formatDate = (date) =>
  `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
